var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('forms-vue',{attrs:{"title":_vm.title,"form":_vm.form,"submit_url":_vm.submit_url,"redirect_submit_url":_vm.redirect_submit_url,"edit_get_url":_vm.edit_get_url,"watch":_vm.watchers,"submit_in_url":_vm.submit_in_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }